// import { getPlatformWebConfig } from '@/services'
import { message, Skeleton } from 'antd'
import Icon from '@ant-design/icons'
import { isNil, trim } from 'lodash-es'
import { FC, useEffect, useLayoutEffect, useRef } from 'react'
import styles from './index.module.less'
import { useNavigate } from 'react-router-dom'
// import loginSvg from './images/login-bg.svg'
// import loginBg from './loginBg'
// import classNames from 'classnames'
// import config from '@/layouts/config'
import useUser from '@/hooks/useUser'
import defaultBg from './images/xiaokui_logo_bg.png'
import bgIcon1 from './images/bg_icon1.png'
import bgIcon2 from './images/bg_icon2.png'
// import defaultTitleImg from './images/shj_logo.png'
// import testBg1 from './images/SVI_login_activity_bg.png'
// import testBg2 from './images/SVI_logo_double_twelve.png'
import { LoginComputer, LoginQrcodeIcon } from './modules/Icon'
import { useDebounceEffect, useSetState } from 'ahooks'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay } from 'swiper/modules'
import RestPassword from './loginResetPassword'
import 'swiper/css'
import * as ww from '@wecom/jssdk'
import { useQRCodeLogin } from '@shj/qrcode-login'
// import gsap from 'gsap'
import * as WWLogin from '@/common/wwLogin-1.2.4'
import LoginAccountForm from '@/pages/login/loginAccountForm'
import { ConfigProvider, Layout, theme } from 'antd'
import loginBg from '@/assets/login_bg.png'
// import LoginSimplify from '@/pages/login-simplify'
import { baseURL } from '@/api'
// import { saasQrCodeLogin } from '@/services'
import {
  getLocalTenants,
  getTenantId,
  getToken,
  setLocalTenants,
  userChangeRemoveStore,
} from '@/common/utils.ts'
import useGlobalStore from '@/store'
import { AccountSelectionModal } from '@/pages/login/AccountSelection.tsx'
import LoginInitialPassword from '@/pages/login/loginInitialPassword.tsx'
import animationQueue from '@/pages/login/modules/animationQueueControl.ts'
import { getLoginParams, X_TRANSFER_KEY } from '@/services'
import { tenantResetInitialPassword } from '@/services/user.ts'

interface ILoginProps {
  name?: string
}

enum loginType {
  pwd = 'password',
  QR = 'QRCode',
}

let isQRCodeInit = false

const VIEW_INDEX = {
  account: 0, // 登陆表单
  resetPassword: 1, // 忘记密码手机验证
  resetPasswordOk: 2, // 忘记密码确认
  initialPassword: 3, // 初始化强制修改密码
}
const Login: FC<ILoginProps> = props => {
  const {
    login,
    postTenantLogin,
    loginPreAuth,
    QRLogin,
    getWebConfig,
    getLoginSuccessRoutePath,
    saveLoginData,
    postLogin,
    postAuthLogin,
  } = useUser()

  const globalTheme = useGlobalStore((state: any) => state.theme)
  const loginFormRef = useRef<any>()
  const preAuth = useRef<any>()
  const saveUserData = useRef<any>()
  const loginDataRef = useRef<any>()

  // if (isPlatform()) return <LoginSimplify {...props} />
  // const [loading, setLoading] = useState(false)
  const [state, setState] = useSetState({
    year: 2024,
    loading: false,
    loginImg: defaultBg,
    titleLogoImg: '',
    loginImageUrls: [],
    passwordVisible: false,
    // loginType: process.env.LOGIN_TYPE || loginType.pwd,
    loginType: loginType.pwd,
    cropId: '',
    agentId: '',
    formData: null,
    scanLoginSwitch: false,
    selectShow: false,
    requireChangePassword: false,
    tenants: [],
    authCode: '',
    userInfo: null,
    password: '',
  })
  const wwLoginRef: any = useRef(null)

  const navigate = useNavigate()

  const [initQRPanel, cancel] = useQRCodeLogin({
    baseURL,
    callback: code => {
      return QRLogin(code, getAgentId()).then(({ path }: any = {}) => navigate(path || '/'))
    },
    // duration: 3000,
  })

  // const pullCode = async id => {
  //   return request('/caas-web/wxControlPanel/getCode', {
  //     method: METHODS.POST,
  //     params: { id },
  //   }).then((res: any) => {
  //     if (res && typeof res === 'string') {
  //       cancel()
  //       QRLogin(res).then(({ path }: any = {}) => navigate(path || '/'))
  //     }
  //     return res
  //   })
  // }
  //
  // const { data, run, cancel } = useRequest(pullCode, {
  //   pollingInterval: 3000,
  //   manual: true,
  // })

  useEffect(() => {
    let date = new Date()
    let year = date.getFullYear()
    setState({ year: year })
  }, [])

  useDebounceEffect(
    () => {
      // ww.register({
      //   corpId: 'ww7ca4776b2a70000', // 必填，当前用户企业所属企业ID
      //   jsApiList: ['createWWLoginPanel'], // 必填，需要使用的JSAPI列表
      //   // getConfigSignature                 // 必填，根据url生成企业签名的回调函数
      // })
      return () => {
        wwLoginRef.current?.unmount?.()
        wwLoginRef.current = null
      }
    },
    [],
    { wait: 300 }
  )

  useDebounceEffect(
    () => {
      if (state.loginType === loginType.QR && state.scanLoginSwitch) {
        initQrLogin()
      } else {
        cancel()
      }
    },
    [state.loginType, state.scanLoginSwitch],
    { wait: 300 }
  )

  useLayoutEffect(() => {
    // setState({ loading: true })
    // getWebConfig()
    //   .then(data => {
    //     // console.log('getWebConfig', data)
    //     const { loginLogo, loginImageUrls, cropId, agentId, scanLoginSwitch } = data
    //     setState({
    //       loginImageUrls: loginImageUrls || [],
    //       titleLogoImg: loginLogo,
    //       cropId,
    //       agentId,
    //       scanLoginSwitch: false,
    //     })
    //     if (!scanLoginSwitch || isNil(cropId) || isNil(agentId)) {
    //       setState({ loginType: loginType.pwd })
    //     }
    //     // setState({ loginType: loginType.pwd })
    //   })
    //   .catch(err => {
    //     setState({ loginType: loginType.pwd })
    //   })
    //   .finally(() => setState({ loading: false }))
    getLoginParams().then(res => {
      if (res['appid']) {
        setState({
          scanLoginSwitch: true,
          cropId: res['appid'],
          agentId: res['agentid'],
        })
      }
    })

    // setState({
    //   scanLoginSwitch: true,
    //   cropId: '1000122',
    //   agentId: 'ww15229442c792c934',
    // })
  }, [])

  const initQrLogin = () => {
    if (!wwLoginRef.current) {
      // QYWWLoginPanel()
      // QYQRCodeInit()

      SHJQRCodeInit()
    }
  }

  const QYWWLoginPanel = () => {
    wwLoginRef.current = ww.createWWLoginPanel({
      el: '#qr_login',
      params: {
        login_type: 'ServiceApp',
        appid: 'ww15229442c792c934',
        agentid: '1000054',
        redirect_uri: encodeURI('https://shj-saas.shjmall.cn'),
        state: 'qr_login',
        redirect_type: 'callback',
        panel_size: 'small',
      },
      // onCheckWeComLogin({ isWeComLogin }) {
      //   console.log(isWeComLogin)
      // },
      onLoginSuccess({ code }) {
        console.log({ code })
      },
      onLoginFail(err) {
        console.log(err)
      },
    })
  }
  const QYQRCodeInit = () => {
    const { protocol, host, pathname } = window.location
    const url = `${protocol}//${host}${pathname}`
    // console.log(state.cropId, state.agentId)
    wwLoginRef.current = new WWLogin({
      id: 'qr_login',
      appid: state.cropId,
      agentid: state.agentId,
      // redirect_uri: encodeURI('https://shj-saas.shjmall.cn'),
      redirect_uri: encodeURI(url),
      state: 'qr_login',
      href: '',
      lang: 'zh',
    })
  }

  const getAgentId = () => state.agentId || process.env.AGENT_ID

  const SHJQRCodeInit = () => {
    const tenantId: string = getTenantId() || ''
    const redirectUrl = `${
      process.env.QR_RESULT_ORIGIN || location.origin
    }/third_docking/wx-qrcode/result.html`
    if (state.cropId) {
      initQRPanel({
        tenantId,
        appid: state.cropId || process.env.APP_ID,
        agentid: getAgentId(),
        redirectUrl,
        id: 'qr_login',
        // qrcodeUrl: 'http://localhost:8080'
        // qrcodeUrl: '/QRCODE',
      })
    }
  }

  const toggleLoginType = () => {
    setState({
      loginType: state.loginType === loginType.pwd ? loginType.QR : loginType.pwd,
    })
  }

  const handleSetFormData = formData => {
    setState({ formData })
  }

  const loginReqFunc = (authCode, record) => {
    return submitLogin(record.userId, authCode, {
      requireChangePassword: record.requireChangePassword,
      tenantId: record.tenantId,
    })
  }

  const handleSelectOk = record => {
    const { authCode } = state
    setState({ authCode: '' })
    if (authCode) {
      return loginReqFunc(authCode, record)
    } else {
      return preAuth.current().then(({ authCode }) => loginReqFunc(authCode, record))
    }
  }

  const routeToIndex = async userInfo => {
    if (userInfo) {
      userChangeRemoveStore()
      const defPath = getLoginSuccessRoutePath(userInfo)
      localStorage.removeItem('tipsShow') // 删除判断变量，重新展示登录身份提示弹框
      navigate(userInfo.path || defPath, { replace: true })
      loginFormRef.current.reset?.()
      preAuth.current = null
      return Promise.resolve()
    } else {
      return Promise.reject()
    }
  }

  const submitLogin = async (userId, authCode, opts: any = {}) => {
    try {
      // console.log('tenantId', tenantId)
      // const userInfo: any = await postTenantLogin(authCode, tenantId)

      if (state.requireChangePassword || opts.requireChangePassword) {
        const loginRes: any = await postLogin(authCode, userId, opts.tenantId)
        loginDataRef.current = {
          token: loginRes?.accessToken?.token,
          tenantId: opts.tenantId,
        }
        saveUserData.current = async () => {
          localStorage.setItem(X_TRANSFER_KEY, opts.tenantId)
          return await saveLoginData(loginRes)
        }
        animationQueue.jump(VIEW_INDEX.initialPassword)
        return Promise.resolve()
      }

      const userInfo: any = await postAuthLogin(authCode, userId, opts.tenantId)
      // 初次登录如果需要修改密码，跳转密码修改页面
      return routeToIndex(userInfo)
    } catch (err) {
      console.log('err', err)
      return Promise.reject(err)
    }
  }

  const preAuthFn = (username, password, type) => {
    return async function () {
      return await loginPreAuth(username, password, type)
    }
  }

  const onFinish = async (values: any, type = 'ACCOUNT') => {
    try {
      const { workNumber, password, code } = values
      const username = trim(`${workNumber}`)
      // setLoading(true
      // const userInfo: any = await postSaaSLogin(username, password)
      const _password = type === 'ACCOUNT' ? password : code
      // const authInfo: any = await loginPreAuth(username, _password, type)

      preAuth.current = preAuthFn(username, _password, type)
      // const { requireChangePassword, tenants, authCode } = await preAuth.current()
      const { tenantAccountInfos, authCode } = await preAuth.current()
      // 存储状态里，修改密码后可使用
      setState({ tenants: tenantAccountInfos, authCode })

      if (tenantAccountInfos) {
        localStorage.setItem('tenants', JSON.stringify(tenantAccountInfos))
      }

      if (tenantAccountInfos?.length > 1) {
        setState({ selectShow: true })
        return Promise.resolve()
      }

      // 租户数量少于2，默认使用第一个租户
      // const res = await submitLogin(tenantAccountInfos[0].userId, authCode, {
      //   requireChangePassword: tenantAccountInfos[0].requireChangePassword,
      //   tenantId: tenantAccountInfos[0].tenantId,
      //  })
      const res = loginReqFunc(authCode, tenantAccountInfos[0])
      // console.log('authInfo', authInfo)
      return res
    } catch (error) {
      // setLoading(false)
      console.log('err', error)
      return Promise.reject(error)
    }
  }

  const onResetOk = async values => {
    return tenantResetInitialPassword(
      { newPassword: values.password },
      {
        [X_TRANSFER_KEY]: loginDataRef.current?.tenantId,
        ['Authorization']: loginDataRef.current?.token,
      }
    ).then(async res => {
      message.success(res?.message || '修改密码成功')
      let userInfo = null
      if (saveUserData.current) {
        userInfo = await saveUserData.current()
        saveUserData.current = null
      }
      loginDataRef.current = null

      return routeToIndex(userInfo)
    })
  }

  const isDev = process.env.NODE_ENV === 'development'

  return (
    <ConfigProvider
      theme={{
        ...globalTheme,
        token: {
          ...globalTheme.token,
          colorPrimary: '#4487EC',
          colorLink: '#4487EC',
        },
      }}
    >
      <div className={styles.loginLayouts}>
        <div className={styles.fixedLayouts}>
          <Swiper
            style={{ position: 'absolute', left: 0, top: 0, width: '100vw', height: '100vh' }}
            loop
            speed={800}
            // spaceBetween={30}
            autoplay={{
              delay: 5500,
              // disableOnInteraction: false,
            }}
            modules={[Autoplay]}
          >
            {state.loginImageUrls?.map?.((url, i) => {
              return (
                <SwiperSlide key={`slide_${i}`}>
                  <div className={styles.bg} style={{ backgroundImage: `url(${url})` }}></div>
                </SwiperSlide>
              )
            })}
          </Swiper>

          {!state.loginImageUrls.length ? (
            <>
              <div
                className={styles.defaultBg}
                style={{ backgroundImage: `url(${loginBg})` }}
              ></div>
              <div className={styles.bgIcon1} style={{ backgroundImage: `url(${bgIcon1})` }}></div>
              <div className={styles.bgIcon2} style={{ backgroundImage: `url(${bgIcon2})` }}></div>
            </>
          ) : null}

          <div className={styles.formLayouts}>
            {state.scanLoginSwitch ? (
              <div className={styles.typeSwitch} onClick={toggleLoginType}>
                <div className={styles.switchIconWrap}>
                  {state.loginType === loginType.pwd ? <Icon component={LoginQrcodeIcon} /> : null}
                  {state.loginType === loginType.QR ? <Icon component={LoginComputer} /> : null}
                </div>
                <div className={styles.insetBoxShadow}></div>
              </div>
            ) : null}
            <div className={styles.accountLogin}>
              {state.loginType === loginType.pwd ? (
                <>
                  <LoginAccountForm
                    ref={loginFormRef}
                    loading={state.loading}
                    onFinish={onFinish}
                    titleLogoImg={state.titleLogoImg}
                    onSetFormData={handleSetFormData}
                  />
                  <LoginInitialPassword tenants={state.tenants} onFinish={onResetOk} />
                  <RestPassword formData={state.formData} />
                </>
              ) : null}

            </div>
            <div
              className={styles.qrCodeLogin}
              style={{ display: state.loginType === loginType.QR ? '' : 'none' }}
            >
              <div id="qr_login" style={{ margin: '0 auto' }}></div>
            </div>
          </div>

          <AccountSelectionModal
            open={state.selectShow}
            data={state.tenants}
            onClose={() => setState({ selectShow: false })}
            onOk={handleSelectOk}
          />

          {/* <div className={styles.footer}>
              <div style={{textAlign: 'center'}}>
                <div>Copyright © 2010-{state.year} Shenghuojia®.All Rights Reserved</div>
                <div>
                  请使用
                  <a
                    style={{color: '#1677ff'}}
                    target="_blank"
                    href="https://www.google.cn/chrome/"
                    rel="noreferrer"
                  >
                    Chrome浏览器
                  </a>
                  获得最佳用户体验
                </div>
              </div>
            </div> */}
        </div>

        <div className={styles.ICP}>
          <a rel="nofollow" href="https://beian.miit.gov.cn">
            备案号：蜀ICP备12017757号-53
          </a>
        </div>
      </div>
    </ConfigProvider>
  )
}

export default Login
